
import { Component, Vue } from "vue-property-decorator";
import FormularioComponent from "@/components/Formulario2026/FormularioResultadoComponent.vue";

@Component({
  components: {
    FormularioComponent
  }
})
export default class FormularioResultadoView extends Vue {}
